import FooterV2 from '@components/FooterV2/index';
import React from 'react';

export default function CertGenFooter() {
  return <FooterV2 />;
}
